import { useInfiniteQuery } from 'react-query';
import { queryGet } from '../../../utils/queryClient';

const DEFAULT_PAGE = 20;

export default function useChatRoomMessages(chatRoomId, perPage) {
  async function fetchChatRoomMessages({ pageParam = 1 }) {
    const queryParams = new URLSearchParams({
      per_page: perPage || DEFAULT_PAGE,
      page: pageParam
    });
    const url = `/api/v1/chat_rooms/${chatRoomId}/chat_room_messages?${queryParams.toString()}`;
    try {
      const chatRooms = await queryGet(url);
      return chatRooms;
    } catch (_error) {
      throw new Error('Error fetching paginated data.');
    }
  }

  const { data, isFetching, fetchNextPage, hasNextPage, refetch, error } = useInfiniteQuery(
    ['ChatRoomMessages', chatRoomId],
    fetchChatRoomMessages,
    {
      enabled: !!chatRoomId,
      getNextPageParam: (lastPage, _) => lastPage?.meta?.pagination?.nextPage,
      cacheTime: 1000 * 60 * 5, // 5분 캐시
      staleTime: 1000 * 30, // 30초 후 stale 상태
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      retry: 2,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000)
    }
  );

  return {
    data,
    isFetching,
    fetchNextPage,
    hasNextPage,
    refetch,
    error
  };
}
